import { useCountryInfo } from 'legacy/lut/hooks/useCountryInfo'
import { useCallback } from 'react'

import { countryWithOptionalURL, marketWithOptionalURL } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import { isValidEmail } from 'core-components/library/validation'

import { REG_BUSINESS_EMAIL_DOMAIN, REG_BUSINESS_URL_DOMAIN } from '../../config/validationRegex'

type UseValidateEmailProps = {
  partner: IPartner
}

/**
 * Local validation
 * Temporary @deprecated
 */
export const useValidateEmail = ({ partner }: UseValidateEmailProps) => {
  const countryInfo = useCountryInfo(partner.country)
  const market = countryInfo?.market
  const urlDomainMatch = partner.url.match(REG_BUSINESS_URL_DOMAIN)
  const businessUrlDomain = urlDomainMatch ? urlDomainMatch[1] : null

  const emailDomainMatch = partner.email.match(REG_BUSINESS_EMAIL_DOMAIN)
  const businessEmailDomain = emailDomainMatch ? emailDomainMatch[1] : null

  const isCountryWithOptionalUrl =
    !partner.country || countryWithOptionalURL.includes(partner.country)
  const isMarketWithOptionalUrl = !market || marketWithOptionalURL.includes(market)

  const onEmailValidate = useCallback(
    (email: string) => {
      if (
        !isCountryWithOptionalUrl &&
        !isMarketWithOptionalUrl &&
        (businessUrlDomain || businessEmailDomain)
      ) {
        if (businessEmailDomain === businessUrlDomain) {
          const isBusinessEmail = email.endsWith(businessUrlDomain!)

          if (!isBusinessEmail) {
            return `Incorrect Email. Please use a business email address that matches your company's domains (${businessUrlDomain})`
          }
        } else {
          const isBusinessEmail =
            (!businessUrlDomain && !businessEmailDomain) ||
            (businessUrlDomain && email.endsWith(businessUrlDomain)) ||
            (businessEmailDomain && email.endsWith(businessEmailDomain))

          if (!isBusinessEmail) {
            return `Incorrect Email. Please use a business email address that matches your company's domains (${businessUrlDomain} or ${businessEmailDomain})`
          }
        }
      }

      return isValidEmail(email)
    },
    [businessEmailDomain, businessUrlDomain, isCountryWithOptionalUrl, isMarketWithOptionalUrl]
  )

  return { onEmailValidate }
}
